import {Flex, Typography} from 'antd';
import React, {Fragment} from 'react';

interface IProps {
  data: any;
  addOn?: any;
}

const TabHeading: React.FC<IProps> = (props) => {
  const {data, addOn = null} = props;

  return (
    <Fragment>
      {addOn ? (
        <Flex align="center">
          <Typography.Title level={2}>{data.heading}</Typography.Title>
          {addOn}
        </Flex>
      ) : (
        <Typography.Title level={2}>{data.heading}</Typography.Title>
      )}
      <Typography.Text>{data.subtitle}</Typography.Text>
    </Fragment>
  );
};

export default TabHeading;
